import React from 'react';
import { Result } from 'antd';

const PageNotFound = () => {
  return <Result status="404" title="404" subTitle="很抱歉，頁面不存在" />;
};

export default PageNotFound;
